import { ModuleWithProviders, NgModule } from '@angular/core';

import { PrivaToggleRouter } from '@priva/utilities/feature-toggles';

import { AppConfigurationService } from 'app/shared/app-configuration';

import { FeatureToggleGuard } from './feature-toggle-guard';

/**
 * Feature Toggle Router
 */
export function getToggleRouter(configService: AppConfigurationService): PrivaToggleRouter {
    const features = configService.configuration.features || [];
    return new PrivaToggleRouter(features);
}

@NgModule({
    imports: [],
    exports: [],
    providers: [],
})
export class ToggleRouterModule {
    static forRoot(): ModuleWithProviders<ToggleRouterModule> {
        return {
            ngModule: ToggleRouterModule,
            providers: [
                {
                    provide: PrivaToggleRouter,
                    useFactory: getToggleRouter,
                    deps: [AppConfigurationService],
                },
                FeatureToggleGuard,
            ],
        };
    }
}
